import { render, staticRenderFns } from "./FormSopimusPaamiesSiirra.vue?vue&type=template&id=5a5e9374&scoped=true&"
import script from "./FormSopimusPaamiesSiirra.vue?vue&type=script&lang=js&"
export * from "./FormSopimusPaamiesSiirra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e9374",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5e9374')) {
      api.createRecord('5a5e9374', component.options)
    } else {
      api.reload('5a5e9374', component.options)
    }
    module.hot.accept("./FormSopimusPaamiesSiirra.vue?vue&type=template&id=5a5e9374&scoped=true&", function () {
      api.rerender('5a5e9374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormSopimusPaamiesSiirra.vue"
export default component.exports